import React, { useEffect } from "react";

const Services = () => {
  useEffect(() => {
    document.title = "Our Solutions - Senior Vault Capital"; // Updated title
  }, []);

  return (
    <div className="bg-[#fff] overflow-x-hidden">
      <section className="relative pt-[10rem]">
        {/* Content Section */}
        <div className="relative px-6 md:px-12 lg:px-20 pb-10">
          {/* Decorative Image */}
          <div className="absolute inset-0 flex justify-center items-center z-0">
            <img
              src="https://cdn.prod.website-files.com/637b8553d2b3433e9297cdb4/63bfdb147093626ba9d65cfa_S.svg"
              alt="Decorative S"
              className="w-72 h-72 opacity-10"
              loading="lazy"
            />
          </div>

          {/* Heading */}
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-6 relative z-10 text-[#000300]">
            Strategic Financial Solutions for Every Goal
          </h1>

          {/* Introduction Paragraph */}
          <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-12 relative z-10 max-w-3xl mx-auto">
            Senior Vault Capital offers a comprehensive suite of services designed to address the diverse financial aspirations of individuals and the dynamic capital needs of businesses.
          </p>

          {/* Core Solution Blocks */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-10">
            {/* Investment & Wealth Advancement */}
            <div className="bg-gray-50/50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h2 className="text-2xl font-semibold mb-4 text-[#000300]">Investment & Wealth Advancement</h2>
              <p className="text-[#000300] text-base mb-4 italic">
                Cultivating Personal and Institutional Wealth
              </p>
              <p className="text-[#000300] text-base mb-4">
                We provide discerning clients access to exclusive investment opportunities and expert advisory services focused on significant wealth growth and strategic asset management.
              </p>
              <div className="mb-4">
                <h3 className="font-semibold text-[#000300]">Key Focus Areas:</h3>
                <ul className="list-disc list-outside pl-5 text-[#000300] text-base">
                  <li className="mb-1">Wealth Management</li>
                  <li className="mb-1">Private Investment Access</li>
                  <li className="mb-1">Diversification Strategies</li>
                  <li>Legacy Planning</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-[#000300]">Ideal For:</h3>
                <ul className="list-disc list-outside pl-5 text-[#000300] text-base">
                  <li className="mb-1">Individuals seeking to grow substantial personal assets</li>
                  <li className="mb-1">Family offices</li>
                  <li>Corporations looking to strategically deploy surplus capital</li>
                </ul>
              </div>
            </div>

            {/* Growth Capital & Project Financing */}
            <div className="bg-gray-50/50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h2 className="text-2xl font-semibold mb-4 text-[#000300]">Growth Capital & Project Financing</h2>
              <p className="text-[#000300] text-base mb-4 italic">
                Securing the Capital Your Ambitions Demand
              </p>
              <p className="text-[#000300] text-base mb-4">
                For ventures poised for significant expansion or projects requiring substantial funding, Senior Vault Capital specializes in sourcing and structuring tailored capital.
              </p>
              <div className="mb-4">
                <h3 className="font-semibold text-[#000300]">Key Offerings:</h3>
                <ul className="list-disc list-outside pl-5 text-[#000300] text-base">
                  <li className="mb-1">Equity Capital (Seed to Series C)</li>
                  <li className="mb-1">Debt Solutions (Term Loans, Project Finance, Bridge Loans)</li>
                  <li>Mezzanine Financing</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-[#000300]">Ideal For:</h3>
                <ul className="list-disc list-outside pl-5 text-[#000300] text-base">
                  <li className="mb-1">Startups</li>
                  <li className="mb-1">SMEs</li>
                  <li className="mb-1">Established corporations</li>
                  <li>Individuals undertaking major investment projects</li>
                </ul>
              </div>
            </div>

            {/* Strategic Financial Advisory */}
            <div className="bg-gray-50/50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h2 className="text-2xl font-semibold mb-4 text-[#000300]">Strategic Financial Advisory</h2>
              <p className="text-[#000300] text-base mb-4 italic">
                Expert Guidance for Complex Financial Endeavors
              </p>
              <p className="text-[#000300] text-base mb-4">
                Our advisory services empower clients to make informed financial decisions for complex assets, capital raises, or strategic financial planning.
              </p>
              <div className="mb-4">
                <h3 className="font-semibold text-[#000300]">Advisory Services Include:</h3>
                <ul className="list-disc list-outside pl-5 text-[#000300] text-base">
                  <li className="mb-1">Financial Modeling</li>
                  <li className="mb-1">Valuation Analysis</li>
                  <li className="mb-1">Investor Readiness</li>
                  <li className="mb-1">Deal Structuring & Negotiation</li>
                  <li>Financial Planning & Risk Management</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-[#000300]">Ideal For:</h3>
                <ul className="list-disc list-outside pl-5 text-[#000300] text-base">
                  <li className="mb-1">Anyone navigating significant financial transitions</li>
                  <li className="mb-1">Preparing for major investments</li>
                  <li>Seeking to optimize their financial strategy</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div className="w-full h-[2px] bg-gray-200 mt-8"></div>
      </section>
    </div>
  );
};

export default Services;